import axios from "axios";
import { api, errorLogger } from "assets/scripts/utilities/api-clients";

export const index = async (options) => {
  const response = await api.get("/kam/address", options);

  return response;
};

export const get = async (userId) => {
  const response = await api.get(`/kam/${userId}/address`);

  return response;
};

export const post = async (userId, payload) => {
  const response = await api.post(`/kam/address/${userId}`, payload);

  return response;
};

export const postSalesAddress = async (userId, payload) => {
  const response = await api.post(`/kam/sales/address/${userId}`, payload);

  return response;
};

export const put = async (userId, payload) => {
  const response = await api.put(`/kam/address/${userId}`, payload);

  return response;
};

export const getPincodeDetails = async (pincode, options = {}) => {
  try {
    const response = await axios.get(
      `https://api.postalpincode.in/pincode/${pincode}`,
      options,
    );

    return response;
  } catch (error) {
    errorLogger(error);

    throw error;
  }
};
